module.exports = __webpack_public_path__ + "static/logo-budge-4c65dacb45ee7261b668b95daf3c03cb.png";